import PhoneNumber from "awesome-phonenumber";
import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import Customer from "interfaces/Customer";
import CustomerContact from "interfaces/CustomerContact";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import "./View.css";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: Customer;
}

export default class Edit extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    private readonly baseUrl: string;

    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {
                id: 0,
                name: "",
                city: "",
                zip: "",
                customerContacts: [],
            },
        };

        this.baseUrl = document
            .getElementsByTagName("base")[0]
            .getAttribute("href")!;
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        var contacts = [];
        for (let i = 0; i < this.state.data.customerContacts.length; i++) {
            contacts.push(
                <ContactPerson
                    key={i}
                    contactData={this.state.data.customerContacts[i]}
                />
            );
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to={this.state.data.externalId ? "/customers-bc" : "/customers-bqs"}>Customers</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>
                            {this.state.data.name}
                        </BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <h3 className="card__title">{this.state.data.name}</h3>
                    <div className="card card--form">
                        <div className="card-block">
                            <div className="form-wrapper customer-view">
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">ID</span>
                                        <span className="field-item">{this.state.data.id}</span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        {BQS && <span className="field-label">Number</span>}
                                        {CQS && <span className="field-label">ID</span>}
                                        <span className="field-item">
                                            {this.state.data.mincronId &&
                                                this.state.data.mincronId.toString()}
                                        </span>
                                    </div>
                                </div>
                                <div className="field-group">
                                    <span className="field-label">Customer Name</span>
                                    <span className="field-item">{this.state.data.name}</span>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Address</span>
                                        <span className="field-item">
                                            {this.state.data.address}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">City</span>
                                        <span className="field-item">{this.state.data.city}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Address 2</span>
                                        <span className="field-item">
                                            {this.state.data.address2}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">State</span>
                                        <span className="field-item">{this.state.data.state}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Address 3</span>
                                        <span className="field-item">
                                            {this.state.data.address3}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Zip</span>
                                        <span className="field-item">{this.state.data.zip}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Phone</span>
                                        <span className="field-item">
                                            {this.state.data.phone &&
                                                new PhoneNumber(this.state.data.phone, "US").getNumber(
                                                    "national"
                                                )}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Fax</span>
                                        <span className="field-item">
                                            {this.state.data.fax &&
                                                new PhoneNumber(this.state.data.fax, "US").getNumber(
                                                    "national"
                                                )}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Salesperson</span>
                                        <span className="field-item">
                                            {this.state.data.salespersonName}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Website</span>
                                        <span className="field-item">
                                            {this.state.data.website}
                                        </span>
                                    </div>
                                </div>
                                <h5 className="section-seprate">Contact Information</h5>
                                {contacts}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "customers/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as Customer;
                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `Viewing ${this.state.data.name} - Customers - ${SITE_NAME}`;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}

interface ContactPersonProps {
    contactData: CustomerContact;
}

const ContactPerson: React.FC<ContactPersonProps> = ({
    contactData,
    ...rest
}) => {
    return (
        <div>
            <div className="row">
                <div className="field-group col-sm-12">
                    <span className="field-label">Contact Person</span>
                    <span className="field-item">
                        {contactData.honorificId ? contactData.honorificName + " " : ""}
                        {contactData.name}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Phone</span>
                    <span className="field-item">
                        {contactData.phone &&
                            new PhoneNumber(contactData.phone, "US").getNumber("national")}
                    </span>
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Title</span>
                    <span className="field-item">{contactData.title}</span>
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Email</span>
                    <span className="field-item">{contactData.email}</span>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./ClientApp/components/customers/View.tsx